import { useEffect } from "react";
import { useCookieConsent } from "../context/CookieConsentContext";

let isHotjarInitialized = false;

const HotjarInit = () => {
  const { prefs } = useCookieConsent();

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    if (!prefs.analytics) {
      if (isHotjarInitialized && typeof window.hj === "function") {
        window.hj("consent", false);
      }
      return undefined;
    }

    const { hostname, protocol } = window.location;
    const isLocalHost =
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname === "[::1]";

    if (protocol !== "https:" || isLocalHost || isHotjarInitialized) {
      return undefined;
    }

    let isCancelled = false;

    const initializeHotjar = async () => {
      const { default: Hotjar } = await import("@hotjar/browser");
      if (isCancelled || isHotjarInitialized) return;

      isHotjarInitialized = Hotjar.init(6478697, 6);
      if (isHotjarInitialized && typeof window.hj === "function") {
        window.hj("consent", true);
      }
    };

    initializeHotjar().catch((error) => {
      console.error("Hotjar initialization failed:", error);
    });

    return () => {
      isCancelled = true;
    };
  }, [prefs.analytics]);

  return null;
};

export default HotjarInit;
